export type SubtitleTrack = {
  label: string
  id: number
}

export const VIDEO_TAG_EVENTS = [
  'audioprocess',
  'canplay',
  'canplaythrough',
  'complete',
  'durationchange',
  'emptied',
  'ended',
  'error',
  'loadeddata',
  'loadedmetadata',
  'loadstart',
  'pause',
  'play',
  'playing',
  'progress',
  'ratechange',
  'seeked',
  'seeking',
  'stalled',
  'suspend',
  'timeupdate',
  'volumechange',
  'waiting',
]

export const HLS_EVENTS = [
  'videotypechanged',
  'subtitletracksloaded',
  'ready',
  'hlsMediaAttaching',
  'hlsMediaAttached',
  'hlsMediaDetaching',
  'hlsMediaDetached',
  'hlsBufferReset',
  'hlsBufferCodecs',
  'hlsBufferCreated',
  'hlsBufferAppending',
  'hlsBufferAppended',
  'hlsBufferEos',
  'hlsBufferFlushing',
  'hlsBufferFlushed',
  'hlsManifestLoading',
  'hlsManifestLoaded',
  'hlsManifestParsed',
  'hlsLevelSwitching',
  'hlsLevelSwitched',
  'hlsLevelLoading',
  'hlsLevelLoaded',
  'hlsLevelUpdated',
  'hlsLevelPtsUpdated',
  'hlsLevelsUpdated',
  'hlsAudioTracksUpdated',
  'hlsAudioTrackSwitching',
  'hlsAudioTrackSwitched',
  'hlsAudioTrackLoading',
  'hlsAudioTrackLoaded',
  'hlsSubtitleTracksUpdated',
  'hlsSubtitleTracksCleared',
  'hlsSubtitleTrackSwitch',
  'hlsSubtitleTrackLoading',
  'hlsSubtitleTrackLoaded',
  'hlsSubtitleFragProcessed',
  'hlsCuesParsed',
  'hlsNonNativeTextTracksFound',
  'hlsInitPtsFound',
  'hlsFragLoading',
  'hlsFragLoadEmergencyAborted',
  'hlsFragLoaded',
  'hlsFragDecrypted',
  'hlsFragParsingInitSegment',
  'hlsFragParsingUserdata',
  'hlsFragParsingMetadata',
  'hlsFragParsed',
  'hlsFragBuffered',
  'hlsFragChanged',
  'hlsFpsDrop',
  'hlsFpsDropLevelCapping',
  'hlsMaxAutoLevelUpdated',
  'hlsError',
  'hlsDestroying',
  'hlsKeyLoading',
  'hlsKeyLoaded',
  'hlsLiveBackBufferReached',
  'hlsBackBufferReached',
  'hlsSteeringManifestLoaded',
]
